import { render, staticRenderFns } from "./ItemGroup.vue?vue&type=template&id=1a551d18&scoped=true"
import script from "./ItemGroup.vue?vue&type=script&lang=ts"
export * from "./ItemGroup.vue?vue&type=script&lang=ts"
import style0 from "./ItemGroup.vue?vue&type=style&index=0&id=1a551d18&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a551d18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a551d18')) {
      api.createRecord('1a551d18', component.options)
    } else {
      api.reload('1a551d18', component.options)
    }
    module.hot.accept("./ItemGroup.vue?vue&type=template&id=1a551d18&scoped=true", function () {
      api.rerender('1a551d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/main-drawer/main-drawer-item/ItemGroup.vue"
export default component.exports